function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigicertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M.29,19c0,10.33,8.38,18.71,18.71,18.71s18.71-8.38,18.71-18.71S29.33.29,19,.29.29,8.67.29,19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.39,21.45c0,1.42.32,2.57.96,3.43.64.86,1.47,1.29,2.51,1.29s1.84-.4,2.52-1.18c.68-.79,1.02-1.98,1.02-3.56,0-1.27-.3-2.36-.91-3.3-.61-.93-1.46-1.39-2.56-1.39-1,0-1.84.42-2.52,1.26-.68.84-1.02,1.99-1.02,3.45h0ZM11.98,21.45c0-2.08.52-3.75,1.55-5.01s2.37-1.89,4-1.89c.53,0,1.03.07,1.48.21.45.14.81.31,1.08.52.27.21.5.42.7.63.2.21.35.38.42.52l.1.21h.05c-.03-.26-.05-.56-.05-.89v-6.1h2.35v18.4h-2.23v-1.25l.02-.89h-.05c-.03.07-.07.16-.14.26-.06.1-.2.3-.41.59-.22.28-.47.54-.75.76-.28.22-.67.42-1.15.59s-1.01.26-1.58.26c-1.65,0-2.96-.63-3.94-1.9s-1.47-2.93-1.47-5h0Z",
    style: {
      fill: "#353535"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigicertIcon);
export default __webpack_public_path__ + "static/media/digicert-icon.210656dd.svg";
export { ForwardRef as ReactComponent };